// Algorithm from https://en.wikipedia.org/wiki/International_Bank_Account_Number#Validating_the_IBAN
export const IBANValidation = (iban: string) => {
  // Move first 4 characters to end of string
  const rearranged = `${iban.slice(4)}${iban.slice(0, 4)}`;

  // Replace letters with digits: A=10, B=11, … Z=35
  // "- 55" to ensure A = 10
  const numeric = rearranged.replace(/[A-Z]/g, (ch) => {
    return (ch.charCodeAt(0) - 55).toString();
  });

  const bigintIban = BigInt(numeric);
  const mod = BigInt(97);

  const expected = BigInt(1);

  // Remainder of iban number MOD 97 === 1
  return bigintIban % mod === expected;
};
